import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { MODE_LABEL } from "@/lib/shipping";

export const DeliverySettingsFields = ({ form, setForm }) => {
  const zones = form.zones || [];
  const mode = form.delivery_mode || "menyusul";
  const setZones = (z) => setForm((f) => ({ ...f, zones: z }));
  const editZone = (i, k, v) => setZones(zones.map((z, j) => (j === i ? { ...z, [k]: v } : z)));

  return (
    <div className="space-y-3 rounded-xl border border-slate-200 p-4" data-testid="delivery-settings">
      <div>
        <p className="text-sm font-semibold text-slate-800">Ongkir Pengiriman (Diantar)</p>
        <p className="text-xs text-slate-500">"Ambil sendiri" selalu gratis.</p>
      </div>
      <div className="grid gap-2">
        {Object.entries(MODE_LABEL).map(([id, label]) => (
          <label key={id} className={`flex cursor-pointer items-center gap-2 rounded-lg border px-3 py-2 text-sm ${mode === id ? "border-emerald-600 bg-emerald-50 font-semibold text-emerald-800" : "border-slate-200 text-slate-600"}`}>
            <input type="radio" name="delivery_mode" value={id} checked={mode === id} onChange={() => setForm((f) => ({ ...f, delivery_mode: id }))} className="accent-emerald-600" data-testid={`settings-delivery-mode-${id}`} />
            {label}
          </label>
        ))}
      </div>
      {mode === "per_km" && (
        <div className="space-y-1.5">
          <Label htmlFor="rate-km">Tarif per km (Rp)</Label>
          <Input id="rate-km" type="number" min="0" required value={form.rate_per_km ?? 0} onChange={(e) => setForm((f) => ({ ...f, rate_per_km: e.target.value }))} data-testid="settings-rate-per-km-input" />
        </div>
      )}
      {mode === "zona" && (
        <div className="space-y-2">
          {zones.map((z, i) => (
            <div key={i} className="grid grid-cols-[1fr_120px_auto] gap-2" data-testid={`settings-zone-row-${i}`}>
              <Input required maxLength={40} value={z.name} onChange={(e) => editZone(i, "name", e.target.value)} placeholder="Nama zona" data-testid={`settings-zone-name-${i}`} />
              <Input required type="number" min="0" value={z.fee} onChange={(e) => editZone(i, "fee", e.target.value)} placeholder="Tarif" data-testid={`settings-zone-fee-${i}`} />
              <Button type="button" size="icon" variant="ghost" className="text-red-600" onClick={() => setZones(zones.filter((_, j) => j !== i))} data-testid={`settings-zone-remove-${i}`}><Trash2 className="h-4 w-4" /></Button>
            </div>
          ))}
          {zones.length < 10 && (
            <Button type="button" variant="outline" size="sm" onClick={() => setZones([...zones, { name: "", fee: "" }])} data-testid="settings-zone-add-button">
              <Plus className="mr-1 h-4 w-4" /> Tambah Zona
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
